// extracted by mini-css-extract-plugin
export var imageCarouselContainer = "index-module--imageCarouselContainer--o73t7";
export var imageCarouselSingleImage = "index-module--imageCarouselSingleImage--luuh2";
export var slick = "index-module--slick--uzGUS";